<template>
  <div class="qa-answer-teacher-list-item">
    <div class="teacher-lis-title">
      <!-- <div class="title">相关咨询师推荐</div> -->
      <titleImg
        :icon="require('images/qa/questions/recommend-zx-title.png')"
        pdb="0rem"
      />
      <div class="more" @click="goConsultIndex">
        <span>查看更多</span>
        <i class="icon-right"></i>
      </div>
    </div>
    <div class="rq-ul">
      <div v-swiper:myFuckSwiper="swiperOptions" class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in list"
            :key="index"
            :class="{
              'swiper-slide item': true,
              large: list && list.length === 1
            }"
            @click="linkToUserIndex(item.user_id, index)"
          >
            <div class="item-left">
              <img :src="item.avatar | imgZip(200)" class="avatar" />
            </div>
            <div class="item-right">
              <div class="top">
                <span class="name">{{ nameFilter(item.name) }}</span>
                <img
                  v-if="item.level_icon"
                  class="icon-level"
                  :src="item.level_icon"
                />
                <img
                  src="~images/qa/anwser/icon-care.png"
                  alt=""
                  class="icon-care"
                />
                <button class="btn">
                  约ta咨询<img
                    src="~images/qa/questions/icon-right3.png"
                    alt=""
                    class="icon-right3"
                  />
                </button>
              </div>
              <div class="dec">{{ item.honor }}</div>
              <div class="tags" v-if="item.tags && item.tags.length">
                擅长领域：
                <span v-for="(tag, index) in item.tags" :key="index">
                  {{ `${tag}${item.tags.length == index + 1 ? '' : ' / '}` }}
                </span>
              </div>
              <div class="num-and-address">
                <span class="zx-num">
                  <span class="num-bold">{{
                    +item.zx_num < 50 ? '近50' : item.zx_num
                  }}</span
                  >人次咨询
                </span>
                <i class="cur">·</i>
                <span class="experience-year">
                  从业<span class="num-bold">{{ item.experience_year }}</span
                  >年
                </span>
                <span class="address">
                  <icon name="dingwei1" class="icon-address" />{{ item.city }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import titleImg from 'component/qa/title.vue'
export default {
  components: {
    titleImg
  },
  props: {
    list: {
      type: [Object, Array],
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    swiperOptions() {
      return {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        autoplay: false,
        pagination: {
          el: '.swiper-pagination'
        },
        on: {
          touchStart: () => this.swiperTouchStart()
        }
        // autoplay: {
        //   disableOnInteraction: false
        // },
      }
    }
  },
  methods: {
    swiperTouchStart() {
      // 神策埋点
    },
    linkToUserIndex(id, index) {
      if (!id) return
      this.$emit('seeOne', id, index + 1)
      this.routerPush(
        `${this.$const.userPage}${id}?_source_page_=回答详情&channle_flag=Platform_content_QA`
      )
    },
    goConsultIndex() {
      this.$emit('seeMore')
      this.routerPush(
        `https://m.xinli001.com/consult?isBack=1&hideNavigationBar=1&channle_flag=Platform_content_QA`
      )
    },
    nameFilter(val) {
      if (!val) return ''
      if (val.length > 3) return val.substring(0, 3) + '...'
      return val
    }
  }
}
</script>
<style lang="scss">
.qa-answer-teacher-list-item {
  margin-top: 20px;
  padding-top: 30px;
  background: #fff;

  .teacher-lis-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    .title {
      font-size: 36px;
      font-weight: 600;
      color: #21252d;
      // font-style: italic;
    }
    .more {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: 400;
      color: #6c798c;
      .icon-right {
        width: 16px;
        height: 16px;
        margin-left: 3px;
        background: url('~images/article/icon-right.png') no-repeat center/100%
          100%;
      }
    }
  }

  .rq-ul {
    width: 100%;
    box-sizing: border-box;
    .swiper-container {
      padding: 0 32px;
      box-sizing: border-box;
      .swiper-wrapper {
        padding: 36px 0 56px 0;
        box-sizing: border-box;
      }
    }
    .swiper-pagination {
      .swiper-pagination-bullet {
        width: 30px !important;
        height: 6px !important;
        background: #f2f4ff !important;
        opacity: 1 !important;
        margin: 0 !important;
        padding: 0;
        border-radius: 4px !important;
        &.swiper-pagination-bullet-active {
          opacity: 1 !important;
          background: #a0b0ff !important;
        }
      }
    }

    .item {
      display: flex;
      // height: 258px;
      width: 658px;
      padding: 30px 32px;
      background: #ffffff;
      box-shadow: 0px 0px 40px 0px #ebefff;
      border-radius: 30px;
      box-sizing: border-box;
      .item-left {
        width: 100px;
        height: 100px;
        margin-right: 16px;
        position: relative;
        .avatar {
          width: 100px;
          height: 100px;
          border-radius: 16px;
          object-fit: cover;
        }
      }
      .item-right {
        flex: 1;
        .top {
          display: flex;
          align-items: center;
          color: #21252d;
          font-size: 20px;
          .name {
            max-width: 132px;
            font-size: 32px;
            line-height: 32px;
            font-weight: bold;
            margin-right: 10px;
            @include overLine(1);
          }
          .icon-level {
            width: 82px;
            height: 30px;
            margin-right: 10px;
          }
          .icon-care {
            width: 133px;
            height: 30px;
          }
        }
        .dec {
          width: 450px;
          font-size: 24px;
          color: #434c5c;
          margin: 18px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .tags {
          width: 450px;
          font-size: 24px;
          line-height: 24px;
          color: #434c5c;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .btn {
          display: flex;
          align-items: center;
          font-size: 22px;
          color: #6982fa;
          line-height: 22px;
          background: transparent;
          margin-left: auto;
          .icon-right3 {
            width: 16px;
            height: 16px;
            margin-left: 3px;
          }
        }
      }
      .num-and-address {
        display: flex;
        align-items: center;
        font-size: 22px;
        color: #434c5c;
        line-height: 24px;
        margin-top: 18px;
        .zx-num,
        .cur,
        .experience-year {
          font-size: 24px;
          line-height: 24px;
          padding-right: 10px;
          white-space: nowrap;
        }
        .num-bold {
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #21252d;
          font-style: normal;
        }
      }
      .address {
        font-size: 22px;
        color: #9da3ac;
        line-height: 22px;
        flex-shrink: 0;
        margin-left: auto;

        .icon-address {
          font-size: 20px;
          line-height: 22px;
          margin-right: 10px;
        }
      }
    }
    .large {
      width: 686px;
    }
  }
}
</style>
